import { API_ORIGIN } from '../api/client.ts';

/**
 * Resolves any image path/URL to a renderable src string.
 *
 * Handles three cases:
 *  1. External CDN/supplier URL (http/https) → returned as-is
 *  2. Path already prefixed with /uploads/    → API_ORIGIN + path
 *  3. Bare filename from server uploads       → API_ORIGIN + /uploads/ + path
 *
 * The API_ORIGIN prefix matters in production: frontend (Vercel) and backend (Railway) are
 * separate origins with no proxy rule for /uploads/*, so a bare relative path 404s there -- it
 * only resolved by accident in dev, where vite.config.ts proxies /uploads/* to localhost:3001 the
 * same way it proxies /api. API_ORIGIN is '' in dev, so relative paths still pass through
 * unchanged there.
 *
 * Returns null when the input is null/undefined/empty so callers can
 * easily fall back to a placeholder.
 */
export function getImageSrc(path: string | null | undefined): string | null {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  if (path.startsWith('/uploads/')) return `${API_ORIGIN}${path}`;
  return `${API_ORIGIN}/uploads/${path}`;
}
